// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"96":"8bbef0fb","166":"9ec66d0b","174":"1f8b9e6c","225":"cded42da","453":"7a96bc15","537":"15568390","545":"de3c183c","589":"42b8af77","665":"d445e11b","745":"3de2d652","771":"a8cecf59","820":"59833ff4","849":"07bc7694","920":"e63d74d6","996":"2a8091ae"}[chunkId] + ".chunk.js";
};